import yup from 'core/utils/validators';
import { FIELD_REQUIRED_PENNY_TRANSFER, getMinLength, ifscRegExp } from 'const';

const { object, string } = yup;

export const PennyTransferFormSchema = () => {
  return object().shape({
    account_number: string()
      .required(FIELD_REQUIRED_PENNY_TRANSFER)
      .min(9, 'The account number must consist of from 9 to 18 digits')
      .max(18, 'The account number must consist of from 9 to 18 digits'),
  });
};

export const PennyTransferIFCSFormSchema = () => {
  return object().shape({
    ifsc_code: string()
      .matches(ifscRegExp, 'message_invalid_ifsc_code')
      .transform((value: string) => value.replace(/\s/g, ''))
      .min(11, getMinLength(11))
      .required(FIELD_REQUIRED_PENNY_TRANSFER),
  });
};
